const radius = {
	s: '2px',
	m: '4px',
	l: '6px',
};

const width = {
	xs: '1px',
	s: '2px',
	m: '4px',
	l: '6px',
	xl: '8px',
};

export { radius, width };
